module.exports = __webpack_public_path__ + "static/media/st-ives.a71e9cb2.jpg";